import { svgToImage } from 'sheet-happens';
import { appColors } from '@base/useTheme';
import * as FarseerIcons from '@components/icons/FarseerIcons';
import * as Icons from '@components/icons/icons';

export const triangleDownImage = svgToImage(<Icons.ChevronCompactDown />);
export const triangleRightImage = svgToImage(<Icons.ChevronCompactRight />);
export const triangleLeftImage = svgToImage(<Icons.ChevronCompactLeft />);

export const linkImage = svgToImage(<FarseerIcons.Link noSpace />);
export const editImage = svgToImage(<FarseerIcons.ChevronDown noSpace />);
export const filterImage = svgToImage(<FarseerIcons.Filter noSpace />);
export const plusImage = svgToImage(<FarseerIcons.Plus noSpace />);
export const ascImage = svgToImage(<FarseerIcons.ArrowUp noSpace />);
export const descImage = svgToImage(<FarseerIcons.ArrowDown noSpace />);
export const textImage = svgToImage(<FarseerIcons.Text noSpace />);
export const numberImage = svgToImage(<FarseerIcons.NumberIcon noSpace />);
export const fileImage = svgToImage(<FarseerIcons.File noSpace />);
export const dateImage = svgToImage(<FarseerIcons.DateIcon noSpace />);
export const connectionImage = svgToImage(<FarseerIcons.Connection noSpace />);
export const loadingImage = svgToImage(<FarseerIcons.Loading noSpace />);
export const goalMarkerImage = svgToImage(<FarseerIcons.GoalMarker noSpace />);
export const cellCommentImage =
    svgToImage(`<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
  <polygon points="10,0 10,10 0,0" style="fill:${appColors.function.w500}" />
</svg>`);

export const sheetIconProps = {
    display: 'icon' as const,
    width: 16,
    height: 16,
    flexAlignSelf: 'start' as const,
};
